const TEXT = {
    LOGIN_CONTENT_TEXT_1:"login",
    LOGIN_CONTENT_TEXT_2:"phone",
    LOGIN_CONTENT_TEXT_3:"please input phone ",
    LOGIN_CONTENT_TEXT_4:"passsword",
    LOGIN_CONTENT_TEXT_5:"please input passsword ",
    LOGIN_CONTENT_TEXT_6:"login commit "
};
export {
	TEXT
}



// WEBPACK FOOTER //
// ./src/config/page/en/login/index.js